import { render, staticRenderFns } from "./DraggableItem.vue?vue&type=template&id=32b2ddc3&scoped=true&"
import script from "./DraggableItem.vue?vue&type=script&lang=js&"
export * from "./DraggableItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=32b2ddc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2ddc3",
  null
  
)

export default component.exports